import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Dropdown, notification, Flex } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import { csvDownload } from "../../helpers/dom";

export const withTableConfig = (WrappedComponent, defaultConfigs = {}) => {
  const TableConfigHOC = ({ title, scrollable = true, exportable = true, ...rest}) => {
    const [data] = useState(defaultConfigs.data || defaultConfigs.dataSource || []);

    const saveCSV = (data, name) => {
      const fields = [];
      const formattedData = [];

      // Extract all keys from the data.
      data.forEach(item => {
        Object.keys(item).forEach(key => {
          if (!fields.includes(key)) {
            fields.push(key);
          }
        });
      });

      // Save all key-value pairs.
      data.forEach(item => {
        const formattedItem = {};
        fields.forEach(field => {
          formattedItem[field] = item[field];
        });
        formattedData.push(formattedItem);
      });

      const fileName = name ? `${name}.csv` : "table.csv";
      csvDownload(formattedData, fields, fileName).catch(() => {
        notification.error({
          message: "Failed to export CSV.",
          key: "csv-download-error"
        });
      });
    };

    const items = [
      {
        key: "csv",
        label: "Export table data as CSV",
        onClick: () => saveCSV(data, title)
      },
    ];

    return (
      <div style={{ width: "100%", textAlign: "center" }}>
        <div style={scrollable ? { position: "relative" } : { position: "relative", width: "100%" }}>
          <Flex align="center" justify="center">
            <h3 style={{ minHeight: "1em"}}>{title}</h3>
            <div style={{ position: "absolute", right: 0 }}>
              {data && exportable && (
                <Dropdown menu={{ items }} placement="bottomRight">
                  <Button icon={<ExportOutlined />} shape="circle" style={{ float: "right", marginRight: 8, zIndex: 2 }} />
                </Dropdown>
              )}
            </div>
          </Flex>
          <WrappedComponent
            dataSource={data}
            {...rest}
          />
        </div>
      </div>
    );
  }

  TableConfigHOC.propTypes = {
    title: PropTypes.string,
    scrollable: PropTypes.bool,
    exportable: PropTypes.bool
  };

  return TableConfigHOC;
};
